import React, { useMemo } from 'react';

const GLYPHS = '01アイウエオカキクケコサシスセソタチツテトナ░▒▓<>{}/=$;_-+*#@!?';

const CodeRain = ({ columns = 28, opacity = 0.35, className = '' }) => {
  const cols = useMemo(() => {
    return Array.from({ length: columns }).map((_, i) => {
      const chars = Array.from({ length: 22 }).map(() =>
        GLYPHS[Math.floor(Math.random() * GLYPHS.length)]
      );
      return {
        id: i,
        chars,
        duration: 5 + Math.random() * 9,
        delay: -Math.random() * 8,
        left: (i / columns) * 100,
      };
    });
  }, [columns]);

  return (
    <div
      className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}
      style={{ opacity }}
      aria-hidden
    >
      <style>{`
        @keyframes coderain-fall {
          0%   { transform: translateY(-110%); }
          100% { transform: translateY(110%); }
        }
      `}</style>
      {cols.map((c) => (
        <div
          key={c.id}
          className="absolute top-0 font-mono text-[12px] leading-[14px] text-matrix-phosphor whitespace-pre"
          style={{
            left: `${c.left}%`,
            animation: `coderain-fall ${c.duration}s linear ${c.delay}s infinite`,
            textShadow: '0 0 6px rgba(0,255,102,0.65)',
          }}
        >
          {c.chars.map((ch, idx) => (
            <span
              key={idx}
              style={{
                display: 'block',
                opacity: 1 - idx / c.chars.length,
              }}
            >
              {ch}
            </span>
          ))}
        </div>
      ))}
    </div>
  );
};

export default CodeRain;
